import { FETCH_COACHES_QUERY } from '@/graphql'
import createCoach from '@/entities/Coach'
import Vue from 'vue'

export default {
  query: FETCH_COACHES_QUERY,
  update(data) {
    Vue.store.commit('pageInfo/SET', {
      ...data?.publicCoaches?.pageInfo,
      totalCount: data?.publicCoaches?.totalCount,
      totalPageCount: data?.publicCoaches?.totalPageCount,
    })

    const publicCoaches = data?.publicCoaches?.edges || []

    let coaches = publicCoaches.map((e) => createCoach(e.node))

    if (this.params.after && this.totalCount === this.coaches.length) {
      return this.coaches
    }

    let result = Array.from(
      new Set(this.coaches.concat(coaches).map((a) => a.id))
    ).map((id) => {
      return this.coaches.concat(coaches).find((a) => a.id === id)
    })

    return this.params.after ? result : coaches
  },
}
